(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1170],{

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 61842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27812);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66261);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Index = function Index(_ref) {
  var links = _ref.links,
      listType = _ref.listType,
      columnGap = _ref.columnGap;

  // ナンバリングのスタート値を計算する
  var setStartValue = function setStartValue(index) {
    var count = 0;
    if (index === 0) return count;

    (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Array(index)).map(function (_, i) {
      return count += links[i].length;
    });

    return count;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    columnGap: columnGap,
    children: links.map(function (arr, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(List, {
        startValue: setStartValue(index),
        listType: listType,
        as: listType === 'disc' ? 'ul' : '',
        children: arr.map(function (_ref2) {
          var name = _ref2.name,
              anchor = _ref2.anchor;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            "data-list-type": listType,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU, {
              to: anchor,
              smooth: true,
              offset: -105,
              children: name
            })
          }, name);
        })
      }, "".concat(arr.toString()).concat(index));
    })
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Index__Wrapper",
  componentId: "sc-19oeg9l-0"
})(["border:1px solid #707070;padding:30px 25px 25px;display:flex;column-gap:", "px;@media screen and (max-width:1047px){flex-direction:column;padding:30px 20px 27px;}"], function (_ref3) {
  var columnGap = _ref3.columnGap;
  return columnGap;
});
var ListStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["color:", ";counter-increment:number;"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var List = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ol.withConfig */ .ZP.ol.withConfig({
  displayName: "Index__List",
  componentId: "sc-19oeg9l-1"
})(["letter-spacing:0.32px;counter-reset:", ";li{line-height:26px;letter-spacing:0.3px;&:hover{opacity:0.7;cursor:pointer;}&[data-list-type='number']::before{", ";content:counter(number) '. ';}&[data-list-type='roman']::before{", ";content:counter(number,upper-roman) '. ';}&[data-list-type='article']::before{", ";content:'' counter(number) '.';}&[data-list-type='disc']::before{content:'';width:6px;height:6px;border-radius:50%;background-color:", ";display:inline-block;margin-right:0.5em;transform:translateY(-50%);}}a{color:", ";}@media screen and (max-width:1047px){li{font-size:15px;}}"], function (_ref4) {
  var startValue = _ref4.startValue,
      listType = _ref4.listType;
  return listType !== 'disc' ? "number ".concat(startValue) : '';
}, ListStyle, ListStyle, ListStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 73799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitleDiv, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleDiv, {
        children: children
      })
    })
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-1mt88t8-0"
})(["display:flex;flex-direction:column;row-gap:10px;text-align:center;font-weight:bold;color:", ";@media screen and (max-width:1047px){color:", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle);
var FontStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:26px;letter-spacing:0;"]);
var TitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__TitleDiv",
  componentId: "sc-1mt88t8-1"
})(["h2{font-weight:bold;font-size:40px;letter-spacing:1.6px;line-height:50px;span{font-size:30px;letter-spacing:1.2px;}}@media screen and (max-width:1047px){h2{line-height:37px;", " span{", "}}}"], FontStyle, FontStyle);

/***/ }),

/***/ 91465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ SectionDiv; },
/* harmony export */   "CK": function() { return /* binding */ StyledList; },
/* harmony export */   "JP": function() { return /* binding */ GridTable2; },
/* harmony export */   "Jn": function() { return /* binding */ GridRow; },
/* harmony export */   "R1": function() { return /* binding */ GridTable; },
/* harmony export */   "U5": function() { return /* binding */ SummaryDiv; },
/* harmony export */   "ZB": function() { return /* binding */ ZenkakuSpace; },
/* harmony export */   "_b": function() { return /* binding */ StyledListInGridRow; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "oH": function() { return /* binding */ StyledListItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["color:", ";text-decoration:underline;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var SummaryDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SummaryDiv",
  componentId: "sc-1vdak17-0"
})(["text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;a{", "}@media screen and (max-width:1047px){font-size:15px;line-height:25px;letter-spacing:0.3px;}"], function (_ref) {
  var color = _ref.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, StyledLink);
var H3Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["font-size:22px;color:", ";font-weight:bold;line-height:30px;letter-spacing:0.88px;@media screen and (max-width:1047px){font-size:15px;letter-spacing:0.6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var StyledH3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "TextStyle__StyledH3",
  componentId: "sc-1vdak17-1"
})(["", ""], H3Style);
var SectionDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SectionDiv",
  componentId: "sc-1vdak17-2"
})(["width:100%;display:flex;flex-direction:column;row-gap:24px;text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;h3{", "}ul{li{max-width:", ";}}ol{padding-left:25px;list-style-type:decimal;}li{span{display:block;font-weight:bold;}}p{span{font-weight:bold;}}a{", "}@media screen and (max-width:1047px){row-gap:30px;font-size:14px;line-height:24px;letter-spacing:0.28px;ul{li{width:100%;}}}"], function (_ref2) {
  var color = _ref2.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, H3Style, function (_ref3) {
  var liWidth = _ref3.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, StyledLink);
var GridTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable",
  componentId: "sc-1vdak17-3"
})(["width:100%;display:grid;grid-template-columns:25% 25% 25% 25%;grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;@media screen and (max-width:1047px){grid-template-columns:50% 50%;}"]); // カラムが６つのテーブル、テーブル内の文章が単語関係なく改行

var GridTable2 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable2",
  componentId: "sc-1vdak17-4"
})(["width:100%;display:grid;grid-template-columns:repeat(6,16.6666667%);grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;word-break:break-all;"]);
var GridRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridRow",
  componentId: "sc-1vdak17-5"
})(["width:100%;display:contents;border-bottom:1px solid #707070;div{border-bottom:1px solid #707070;border-right:1px solid #707070;padding:20px 20px;}@media screen and (max-width:1047px){margin:0px 20px;div{padding:16px 20px 18px;}}"]);
var StyledList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "TextStyle__StyledList",
  componentId: "sc-1vdak17-6"
})(["counter-reset:number ", ";max-width:", ";margin-left:", ";@media screen and (max-width:1047px){width:100%;margin-left:0;padding-left:", ";}"], function (_ref4) {
  var startValue = _ref4.startValue;
  return startValue === undefined ? '' : startValue;
}, function (_ref5) {
  var liWidth = _ref5.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, function (_ref6) {
  var marginLeft = _ref6.marginLeft;
  return marginLeft === undefined ? '0' : "".concat(marginLeft, "em");
}, function (_ref7) {
  var paddingLeft = _ref7.paddingLeft;
  return paddingLeft === undefined ? '0' : "".concat(paddingLeft, "em");
});
var StyledListInGridRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StyledList).withConfig({
  displayName: "TextStyle__StyledListInGridRow",
  componentId: "sc-1vdak17-7"
})(["padding-left:0.8em;"]);
var Article = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var BoldArticle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;font-weight:bold;p{text-indent:0em;font-weight:400;}::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var Disc = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["text-indent:-1em;::before{counter-increment:number;content:'\u30FB';}"]);
var Comment = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-3.5em;::before{counter-increment:number;content:'\uFF08Note' counter(number) '\uFF09';}@media screen and (max-width:1047px){text-indent:-0.5em;}"]);
var Number = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-1.5em;::before{counter-increment:number;content:counter(number) '. ';}"]);
var StyledListItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "TextStyle__StyledListItem",
  componentId: "sc-1vdak17-8"
})(["font-weight:400;", " ", ";", ";"], function (_ref8) {
  var listType = _ref8.listType;

  switch (listType) {
    case 'article':
      return Article;

    case 'disc':
      return Disc;

    case 'comment':
      return Comment;

    case 'boldArticle':
      return BoldArticle;

    case 'number':
      return Number;

    case undefined:
      break;
  }
}, function (_ref9) {
  var paddingLeft = _ref9.paddingLeft;
  return paddingLeft && "padding-left:".concat(paddingLeft, "em");
}, function (_ref10) {
  var textIndent = _ref10.textIndent;
  return textIndent && "text-indent:".concat(textIndent, "em");
});
var ZenkakuSpace = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TextStyle__ZenkakuSpace",
  componentId: "sc-1vdak17-9"
})(["padding-left:", ";"], function (_ref11) {
  var space = _ref11.space;
  return space === undefined ? '1em' : "".concat(space, "em");
});

/***/ }),

/***/ 51542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ UsingTermsPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/enpages/Legal/TextStyle.tsx
var TextStyle = __webpack_require__(91465);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Legal/UsingTerms/UsingIterms.tsx




var usingTerms = [{
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledH3 */.eX, {
      children: "1. Copyrights"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Unless otherwise stated, the copyright of all the information on the Website, including but not limited to documents and images, belongs to TRIAL Group."
    })]
  }),
  id: 'copyright'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledH3 */.eX, {
      children: "2. Text and Contents"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["Although TRIAL Group has taken the utmost care in posting information on the Website, we make no warranty of any kind regarding any errors or defects in the content of the Website. TRIAL Group shall not be liable for any damages resulting from the use of the Website.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Please note that the information on the Website may be subject to change or discontinuation without notice."]
    })]
  }),
  id: 'article'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledH3 */.eX, {
      children: "3. Prohibited Matters"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "In addition to the acts prohibited by the provisions of the Terms, Users shall not engage in any of the following acts when using the Website."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Actions that infringe or may infringe the rights, interests, or privacy of TRIAL Group or any third party."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Actions that cause or may cause trouble or damage to TRIAL Group or any third party."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Actions that damage the reputation or credibility of TRIAL Group or any third party."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Actions that are or may be offensive to public order and morals, or that violate or may violate laws, regulations, or ordinances."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Criminal acts or acts that lead or may lead to criminal acts."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Actions that are intended to conduct business or commercial activities using the Website, or actions in preparation for such activities."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Actions that interfere with the operation of the Website or may interfere with the provision of services of TRIAL Group."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Actions that use, provide, or may use or provide harmful programs such as computer viruses"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Any other acts that TRIAL Group deems inappropriate."
      })]
    })]
  }),
  id: 'restriction'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledH3 */.eX, {
      children: "4. Suspension or Shutdown of the Website"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "TRIAL Group may suspend or shut down the Website (including temporary suspension) due to system maintenance (whether regular or irregular), force majeure such as natural disasters, unavoidable circumstances, or TRIAL Group's sole discretion. TRIAL Group shall not be liable for any disadvantage or damage, etc. incurred by Users due to their inability to use the Website."
    })]
  }),
  id: 'stoppage'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledH3 */.eX, {
      children: "5. Subject Countries and Regions of Products and Services"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "The information contained on the Website is related to products/services offered in Japan and can only be purchased/obtained by residents of Japan. If the country/region of supply is indicated individually in the content, or if the content is linked to the information of such country/region, such information shall take precedence."
    })]
  }),
  id: 'region'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledH3 */.eX, {
      children: "6. Link to the Website"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["Users are free to link to the Website if the link is to the top page.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "However, Users shall follow the precautions below."]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          style: {
            color: '#002D65'
          },
          children: "Precautions for Links"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "0.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "article",
            children: "Please clearly indicate \u201CTRIAL Group\u201D."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "article",
            children: "Please refrain from using the logo of TRIAL Group."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "article",
            children: "Please display the Website in an independent window and clearly identify it as website of TRIAL Group."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
            listType: "article",
            children: ["Links to the Website by the following types of websites are strictly prohibited.", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
              marginLeft: "1",
              paddingLeft: "0.5",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
                listType: "disc",
                children: "Websites with content that infringes the rights of TRIAL Group or any third party."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
                listType: "disc",
                children: "Websites with content that causes misunderstanding, misconception, or annoyance to TRIAL Group or any third party."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
                listType: "disc",
                children: "Websites with content that offends public order and morals."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
                listType: "disc",
                children: "Websites with content related to illegal or potentially illegal expressions or activities."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
                listType: "disc",
                children: "Other websites that TRIAL Group deems inappropriate as the link source."
              })]
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: ["Please be aware that if you do not follow the linking methods and precautions described above, TRIAL Group may request the deletion of the link.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Please remove the link immediately after the request is made."]
        })
      })]
    })]
  }),
  id: 'links'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Date of Enactment : December 26, 2022"
    })
  }),
  id: 'enactment'
}];
var usingTermsLinks = [[{
  name: '（ Copyrights）',
  anchor: 'copyright'
}, {
  name: '（Text and Contents）',
  anchor: 'article'
}, {
  name: '（Prohibited Matters）',
  anchor: 'restriction'
}], [{
  name: '（Suspension or Shutdown of the Website ）',
  anchor: 'stoppage'
}, {
  name: '（Subject Countries and Regions of Products and Services）',
  anchor: 'region'
}, {
  name: '（Link to the Website）',
  anchor: 'links'
}]];
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Legal/Index/index.tsx
var Index = __webpack_require__(61842);
// EXTERNAL MODULE: ./src/components/enlayouts/Legal/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(73799);
;// CONCATENATED MODULE: ./src/components/enpages/Legal/UsingTerms/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var sectionTitle = {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
    children: "Terms of Use"
  })
};

var tSummary = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
    children: ["Regarding this website (hereinafter referred to as the \u201CWebsite\u201D) which is operated by TRIAL Group (representing TRIAL Holdings, Inc., and its group companies*.), the users of the Website (hereinafter referred to as the \"Users\") are deemed to have agreed to the Terms of Use (hereinafter referred to as the \"Terms\") by using it.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Besides, the Terms may be changed. Users are requested to check the latest content of the Terms."]
  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
    children: ["\u203B", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
      path: "/en/company/overview/",
      text: "Here "
    }), "are the group companies of TRIAL Holdings, Inc."]
  })]
});

var UsingTermsPage = function UsingTermsPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Terms of Use",
      description: "The terms of Use for TRIAL Holding, Inc.",
      ogp: {
        type: 'article',
        url: 'en/legal/terms/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(UsingContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, _objectSpread({}, sectionTitle)), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 60
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SummaryDiv */.U5, {
        children: tSummary
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 35
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Index/* Index */.g, {
        columnGap: 84,
        listType: "article",
        links: usingTermsLinks
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 40
        }
      }), usingTerms.map(function (_ref, index) {
        var children = _ref.children,
            id = _ref.id;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SectionDiv */.$V, {
            id: id,
            children: children
          }), index < usingTerms.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              pc: 70,
              sp: 39
            }
          })]
        }, "".concat(id).concat(index));
      })]
    })]
  });
};

UsingTermsPage.getLayout = function (page) {
  var pageTitle = {
    title: 'Legal',
    subTitle: ''
  };
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Legal',
    path: '/en/legal/'
  }, {
    name: 'Terms of Use',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: false,
    children: page
  }));
};

var UsingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "UsingTerms__UsingContainer",
  componentId: "sc-13f79j1-0"
})(["width:1040px;padding-top:62px;padding-bottom:130px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:40px 20px 70px;}"]);
;// CONCATENATED MODULE: ./src/pages/en/legal/terms.tsx


/***/ }),

/***/ 43401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal/terms",
      function () {
        return __webpack_require__(51542);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,4591,9774,2888,179], function() { return __webpack_exec__(43401); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);